const BIZY_NAVIGATION_ROW_SELECTED = 'secondary.bgAlphaActive' as const;
const BIZY_NAVIGATION_ROW_HOVER = 'secondary.bgAlpha' as const;

interface BizyNavigationRowStyles {
	bg: typeof BIZY_NAVIGATION_ROW_SELECTED | 'transparent';
	_hover?: { bg: typeof BIZY_NAVIGATION_ROW_SELECTED | typeof BIZY_NAVIGATION_ROW_HOVER };
	_active?: { bg: typeof BIZY_NAVIGATION_ROW_SELECTED | typeof BIZY_NAVIGATION_ROW_HOVER };
}

export function getBizyNavigationRowStyles(isCurrent: boolean, isInteractive = true): BizyNavigationRowStyles {
	return {
		bg: isCurrent ? BIZY_NAVIGATION_ROW_SELECTED : 'transparent',
		...(isInteractive && {
			_hover: { bg: isCurrent ? BIZY_NAVIGATION_ROW_SELECTED : BIZY_NAVIGATION_ROW_HOVER },
			_active: { bg: isCurrent ? BIZY_NAVIGATION_ROW_SELECTED : BIZY_NAVIGATION_ROW_HOVER },
		}),
	};
}
